import { render } from "./FpIconsDropDown.vue?vue&type=template&id=2c47e01c&scoped=true"
import script from "./FpIconsDropDown.vue?vue&type=script&lang=js"
export * from "./FpIconsDropDown.vue?vue&type=script&lang=js"

import "./FpIconsDropDown.vue?vue&type=style&index=0&id=2c47e01c&scoped=true&lang=css"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c47e01c"]])

export default __exports__